// extracted by mini-css-extract-plugin
module.exports = {"values":"styles_values__h1DGo","card":"styles_card__3rPNk","pulse":"styles_pulse__tbUmg","jump":"styles_jump__ceAQm","wiggle":"styles_wiggle__Io6SM"};